const BASE_URL = "https://habit-backend-7mh4.onrender.com/api/users";
export default BASE_URL;
